import { useTranslation } from 'react-i18next';
import { usePermissions } from '../../core/authorization/PermissionProvider';
import { HubEmpty, HubTitle } from '../hub/HubUi';
import { PromotionPlans } from './PromotionPlans';
import './billing.css';

export function PromotionsPage() {
  const { t } = useTranslation();
  const { hasScope } = usePermissions();
  return <div className="bl-page">
    <HubTitle title={t('promotions.pageTitle', 'Promotions')} />
    {hasScope('platform.organization.manage') ? <>
      <PromotionPlans />
      {hasScope('platform.organization.provision') && <PromotionPlans admin />}
    </> : <HubEmpty>{t('billing.adminOnly', 'Only company administrators can manage plans.')}</HubEmpty>}
  </div>;
}
